import { SELECTORS } from './constants';
import { HIDDEN } from '../classnames/design-system';
import { SelectDropdown } from '../shared/select-dropdown-v2';

export class Overview {
  constructor(onChangeFilter) {
    this.container = document.querySelector(`.${SELECTORS.REVIEWS}`);
    this.productFilter = document.querySelector(`.${SELECTORS.FILTER}`);

    if (this.productFilter) {
      new SelectDropdown(this.productFilter, onChangeFilter).init();
    }
  }

  render = (rating, count) => {
    this.toggleZeroState(count);
    this.renderRating(rating);
    this.renderTotalCount(count);
  };

  renderRating = (rating) => {
    const ratingContainer = this.container.querySelector(`.${SELECTORS.AVERAGE_RATING}`);
    const zeroRatingContainer = this.container.querySelector(`.${SELECTORS.ZERO_AVERAGE_RATING}`);

    if (rating > 0) {
      const ratingElement = ratingContainer.querySelector(`.${SELECTORS.AVERAGE_RATING_COUNT}`);

      ratingElement.innerHTML = rating;
      ratingContainer.classList.remove(HIDDEN);
      zeroRatingContainer.classList.add(HIDDEN);
    } else {
      ratingContainer.classList.add(HIDDEN);
      zeroRatingContainer.classList.remove(HIDDEN);
    }
  };

  renderTotalCount = (count) => {
    const totalReviews = this.container.querySelector(`.${SELECTORS.TOTAL_COUNT}`);

    totalReviews.innerHTML = count;
  };

  toggleZeroState = (count) => {
    const zeroState = this.container.querySelector(`.${SELECTORS.ZERO_STATE}`);
    const zeroRating = this.container.querySelector(`.${SELECTORS.REVIEWS_RATING_STARS}`);

    if (count > 0) {
      zeroState.classList.add(HIDDEN);
      zeroRating.classList.remove(HIDDEN);
    } else {
      zeroState.classList.remove(HIDDEN);
      zeroRating.classList.add(HIDDEN);
    }
  };
}
